import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AccountUserList from './components/AccountUserList';

const { Cell } = ResponsiveGrid;

const AccountList = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="個人帳號列表"
        // description="公告事項"
        breadcrumbs={[
          {
            name: '帳號管理',
          },
          {
            name: '個人帳號列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AccountUserList />
    </Cell>
  </ResponsiveGrid>
);

export default AccountList;
